import { render, staticRenderFns } from "./ClientReport.vue?vue&type=template&id=00ad09d6"
import script from "./ClientReport.vue?vue&type=script&lang=js"
export * from "./ClientReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports